export default "__VITE_ASSET__B97$BHqn__"